import type { ComputedRef, InjectionKey, Ref } from "vue";
import type { DataItem, TabBoxConfig, ToggleButtonConfig } from "..";

export const RadioButtonModelInjectionKey = Symbol(
  "radioButtonModelInjectionKey"
) as InjectionKey<Ref<string | number | undefined>>;

export const ToggleButtonConfigInjectionKey = Symbol(
  "toggleButtonConfigInjectionKey"
) as InjectionKey<ComputedRef<ToggleButtonConfig>>;

export const TabBoxConfigInjectionKey = Symbol(
  "tabBoxConfigInjectionKey"
) as InjectionKey<ComputedRef<TabBoxConfig>>;

export const CompositionBackgroundCardInjectionKey = Symbol(
  "compositionBackgroundCardInjectionKey"
) as InjectionKey<Ref<boolean>>;

export const SimpleTableContextInjectionKey = Symbol(
  "simpleTableContextInjectionKey"
) as InjectionKey<{
  containsRenderAsCard: Ref<boolean>;
  containsRenderAsCardExtension: Ref<boolean>;
}>;

export const isDataItem = (item: any): item is DataItem<string> =>
  !!item && typeof item === "object" && "id" in item;

export const isEqualItem = <T, K>(a: T, b: K) => {
  return isDataItem(a) && !isDataItem(b)
    ? b === a.id
    : isDataItem(b) && !isDataItem(a)
    ? b.id === a
    : isDataItem(b) && isDataItem(a)
    ? b.id === a.id
    : (b as any) === (a as any);
};
